// 系统管理角色
const mainAuth = [
  {
    icon: "iconfont icon-shouye-shouye",
    router: "/admin/index",
    name: "首页",
  },
  {
    icon: "iconfont icon-xiangmuguanli",
    router: "/admin/project",
    name: "项目管理",
  },
  {
    icon: "iconfont icon-jianxiujihua",
    router: "/admin/device",
    name: "设备管理",
  },{
    icon:"icon icon-xitongrizhi",
    router:'/admin/task',
    name:'设备日志',
    children:[
      {
        icon: "iconfont icon-ludeng",
        router: "/admin/task",
        name: "任务日志",
      },{
        icon:"iconfont icon-jiancejilu-xian",
        router:"/admin/DetectionRecord",
        name:"检测记录",
      }
    ]
  },
  {
    icon: "iconfont icon-jichuxinxiguanli",
    router: "/admin/product",
    name: "基础信息",
    children: [
      {
        icon: "iconfont icon-chanpinjishu",
        router: "/admin/product",
        name: "产品型号",
      },
      {
        icon: "iconfont icon-yidongduanbanben",
        router: "/admin/ver",
        name: "应用版本",
      },
    ],
  },
  {
    icon: "iconfont icon-mobanguanli",
    router: "/admin/template",
    name: "模板管理",
    children: [
      {
        icon: "iconfont icon-mobanguanli",
        router: "/admin/template",
        name: "模板管理",
      },
      {
        icon: "iconfont icon-tubiaolunkuo-",
        router: "/admin/homeowner",
        name: "厂家管理",
      },
    ],
  },
  {
    icon: "iconfont icon-xitong",
    router: "/admin/user",
    name: "系统管理",
    children: [
      {
        icon: "iconfont icon-kehu",
        router: "/admin/user",
        name: "用户管理",
      },
      {
        icon: "iconfont icon-xitongrizhi1",
        router: "/admin/log",
        name: "系统日志",
      }
    ],
  },
];
export default mainAuth;
